import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';

const CohortAffinitySkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
  margin: ${spacing.plusHalf};
`;

export const CohortAffinityUsersSkeletonId = 'cohort-affinity-users-skeleton';

export const CohortAffinitySkeleton = () => {
  return (
    <CohortAffinitySkeletonContainer data-test={CohortAffinityUsersSkeletonId}>
      <Skeleton width={500} height={34} isRound={true} />
      <Skeleton width={500} height={16} isRound={true} />
    </CohortAffinitySkeletonContainer>
  );
};
